export enum WorkspaceUserStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  NOT_ACTIVE = 'NOT_ACTIVE',
}
